import { useEffect, useState } from "react";
import axios from "axios";
import BlogCard from "./BlogCard";
import EditBlogForm from "./EditBlogForm";

export default function ManageBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [editingBlog, setEditingBlog] = useState(null);
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_BASE}blogs`);
      setBlogs(res.data);
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (blogId) => {
    try {
      await axios.delete(`${API_BASE}blogs/${blogId}`);
      setBlogs(blogs.filter((b) => b.id !== blogId));
    } catch (error) {
      console.error("Failed to delete blog:", error);
    }
  };

  const handleEdit = async (blog) => {
    try {
      const res = await axios.get(`${API_BASE}blogs/${blog.id}`);
      setEditingBlog(res.data);
    } catch (error) {
      console.error("Failed to fetch blog details:", error);
    }
  };

  const handleEditSuccess = () => {
    setEditingBlog(null);
    fetchBlogs();
  };

  if (editingBlog) {
    return (
      <EditBlogForm
        blog={editingBlog}
        onCancel={() => setEditingBlog(null)}
        onSuccess={handleEditSuccess}
      />
    );
  }

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Manage Blogs</h2>
      <div className="grid gap-4">
        {blogs.map((blog) => (
          <BlogCard
            key={blog.id}
            blog={blog}
            onDelete={handleDelete}
            onEdit={handleEdit}
          />
        ))}
      </div>
    </div>
  );
}
